import React, { useCallback, useEffect, useState } from 'react';
import {
  IconCloseCircleFilled,
  IconSearch,
  Input,
  Select,
} from 'takeat-design-system-ui-kit';
import api from '~/services/api';
import toast from 'react-hot-toast';
import { Container, Header, Title, SearchArea, Content } from './styles';
import Category from './Category';
import { LoadingPage } from '~/components/LoadingPage';

export default function EanCodeRelation() {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');

  const getCategories = useCallback(async () => {
    setIsLoading(true);

    const response = await api.get('/restaurants/products');

    const formattedCategories = response.data.map((category) => ({
      value: category.id,
      label: category.name,
    }));

    setCategoriesOptions([
      { label: 'Todas as categorias', value: '' },
      ...formattedCategories,
    ]);

    setCategories(response.data);
    setFilteredCategories(response.data);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  function handleFilterCategory(categoryId) {
    if (categoryId === '') {
      setFilteredCategories(categories);
      return;
    }
    const filteredOptionCategories = categories.filter(
      (category) => category.id === categoryId
    );
    setFilteredCategories(filteredOptionCategories);
  }

  // filtro de produto
  const [searchInputProd, setSearchInputProd] = useState('');

  async function handleSearchInputProduct(name) {
    if (name.length >= 3) {
      try {
        const productFind = categories.map((cat) =>
          cat.products.map((prod) => {
            if (
              prod.name
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .includes(
                  name
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                )
            ) {
              return { ...cat, products: [prod] };
            }
            return '';
          })
        );

        const arrayReady = productFind
          .map((item) => item.filter((cat) => cat !== ''))
          .filter((arr) => arr.length > 0);

        const newArray = arrayReady.flatMap((item) => item);

        const output = newArray.reduce(function (o, cur) {
          const occurs = o.reduce(function (n, item, i) {
            return item.name === cur.name ? i : n;
          }, -1);

          if (occurs >= 0) {
            o[occurs].products = o[occurs].products.concat(cur.products);
          } else {
            const obj = {
              name: cur.name,
              ...cur,
            };
            o = o.concat([obj]);
          }

          return o;
        }, []);

        setFilteredCategories(output);
      } catch (error) {
        toast.error('erro ao filtrar');
      }
    }

    if (name.length === 0) {
      setFilteredCategories(categories);
    }
  }

  useEffect(() => {
    handleSearchInputProduct(searchInputProd);
  }, [searchInputProd]);

  return isLoading ? (
    <LoadingPage />
  ) : (
    <Container>
      <Header>
        <Title>Produtos por código de barra EAN</Title>
        <SearchArea>
          <Input
            placeholder="Buscar Produto"
            value={searchInputProd}
            iconLeft={<IconSearch />}
            onChange={(e) => setSearchInputProd(e.target.value)}
            iconRight={
              <IconCloseCircleFilled onClick={() => setSearchInputProd('')} />
            }
            containerStyles={{
              width: 210,
            }}
          />
          <Select
            placeholder="Todos as categorias"
            options={categoriesOptions}
            containerStyles={{
              width: 210,
            }}
            onChange={(e) => {
              handleFilterCategory(e.value);
            }}
          />
        </SearchArea>
      </Header>
      <Content>
        {filteredCategories &&
          filteredCategories.map((category) => (
            <Category key={category.id} category={category} />
          ))}
      </Content>
    </Container>
  );
}
